// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2FZpr","description":"PatientConsentPreview_description__3l7d1"};